module.exports = __webpack_public_path__ + "images/course-library.png";